import { render, staticRenderFns } from "./ModalEditarDesenho.vue?vue&type=template&id=6695435c&scoped=true"
import script from "./ModalEditarDesenho.vue?vue&type=script&lang=js"
export * from "./ModalEditarDesenho.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarDesenho.vue?vue&type=style&index=0&id=6695435c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6695435c",
  null
  
)

export default component.exports